// extracted by mini-css-extract-plugin
module.exports = {"finalSaleBanner":"FinalSalePDP_finalSaleBanner__Tnr7o","promoLink":"FinalSalePDP_promoLink__H4ota"};